export default "__VITE_ASSET__CXE_fGwG__"